import { Table, Tag } from 'antd'
import { useEffect, useState } from 'react'
/**
 *
 * @param {Array} data 表格数据
 * @param {Object} params 表格其他参数
 * @param {Boolean} canCheck 能否被选择
 * @param {Function} onChange 表格行被筛选时的方法
 * @param {Boolean} isAfterSale 是否是售后商品表格 默认false
 * @returns
 */
const ProductTable = (props) => {
  const {
    data,
    params = {},
    canCheck,
    onChange = () => {},
    isAfterSale,
  } = props
  const [selection, setSelection] = useState({})
  const columns = [
    {
      title: '商品序号',
      key: 'index',
      align: 'center',
      render: (text, record, index) => index + 1,
    },
    {
      title: '商品编码',
      dataIndex: 'skuNo',
      key: 'skuNo',
      align: 'center',
    },
    {
      title: '条码',
      dataIndex: 'barcode',
      key: 'barcode',
      align: 'center',
    },
    {
      title: '商品名称',
      dataIndex: 'productName',
      key: 'productName',
      align: 'center',
      render: (text, record, index) => (
        <div className='product-name-box'>
          <span>{ record.productName ? record.productName : '-' }</span>
          {/* <Tag style={{ marginLeft: '0.2rem ', display: record.aftersaleStatus ? 'block' : 'none'}}>
            { 
              record.aftersaleStatus == 1 ? '未审核' 
              : record.aftersaleStatus == 2 ? '审核通过' : 
              record.aftersaleStatus == 3 ? '驳回' : '--'
            }
            </Tag> */}
            <Tag style={{ marginLeft: '0.2rem ', display: record.aftersaleStatus ? 'block' : 'none'}}>
            { 
              record.aftersaleStatus == 'un_audit' ? '售后中' 
              : record.aftersaleStatus == 'finish' ? '已售后' :
               '--'
            }
            </Tag>
        </div>
      )
    },
    {
      title: '规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
    },
    {
      title: '包装单位',
      dataIndex: 'unit',
      key: 'unit',
      align: 'center',
    },
    {
      title: '单价（元）',
      dataIndex: 'salePrice',
      key: 'salePrice',
      align: 'center',
      render: (text) => (text ? '￥' + text : ''),
    },
    {
      title: isAfterSale ? '退款数量' : '数量',
      dataIndex: 'count',
      key: 'count',
      align: 'center',
    },
    {
      title: '计价方式',
      dataIndex: 'saleWay',
      key: 'saleWay',
      align: 'center',
    },
    {
      title: '总金额（元）',
      dataIndex: 'saleAmount',
      key: 'saleAmount',
      align: 'center',
      render: (text, record) =>
        text || record.refundAmount
          ? '￥' + (isAfterSale ? record.refundAmount : text)
          : '',
    },
    {
      title: isAfterSale ? '实退金额（元）' : '成交金额（元）',
      dataIndex: 'saleAmount',
      key: 'saleAmount',
      align: 'center',
      render: (text, record) =>
        text || record.refundAmount
          ? '￥' + (isAfterSale ? record.refundAmount : text)
          : '',
    },
  ]
  useEffect(() => {
    canCheck
      ? setSelection({ rowSelection: { type: 'checkbox', onChange } })
      : setSelection({})
  }, [canCheck])
  return (
    <Table
      size="middle"
      bordered
      columns={columns}
      dataSource={data}
      pagination={false}
      rowKey="skuNo"
      {...selection}
      {...params}
    />
  )
}
export default ProductTable
